import { createContext } from '@chakra-ui/react-utils';

import type { IconButtonSize } from './types';

interface IconButtonGroupContext {
  size?: IconButtonSize;
  isDisabled?: boolean;
}

const [IconButtonGroupProvider, useIconButtonGroup] =
  createContext<IconButtonGroupContext>({
    strict: false,
    name: 'IconButton Context',
  });

export { IconButtonGroupProvider, useIconButtonGroup };
